<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="prologue">
<h1>Prologue</h1>
<p>Ladies and Gentlemen.</p>
<p>Let me introduce you to the band.</p>
<p>On drums—all the way from East Finchley, via Cape Cod, it’s the Prince of the Hi-Hats, the Titan of Toms, the Sultan of Snare—Mr Cyrus Dactyl!</p>
<p>On bass guitar—dig those deep-down dirty tones—give it up for oedipally-challenged posh boy—Mr Brendan Bazzle!</p>
<p>On rhythm guitar, coaxing the love from those worn-out frets, it’s the rottweiler of rock—Pete Dankpatch!</p>
<p>Caressing the ivories, on keyboards, the incomparable, irreplaceable Mr Duff Jones!</p>
<p>On horn let’s hear it for that sultry seducer of the saxophone, Mr Max Beauregard!</p>
<p>Belting out the backing vocals, put your hands together for the Queen of the Scream—Miss Flimsy Wipers!</p>
<p>And last but not least, on lead vocals, it’s yours truly—numero uno, Il Duce.</p>
<p>The Guv’nor.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?7216ddd8